<template>
  <section class="instagram-star">
    <div class="hero">
      <div class="hero-body">
        <h1 class="title">Become a WitBlox<br>Instagram Star</h1>
        <p class="subtitle">Share your WitBlox creations on<br>Instagram and earn rewards!</p>
      </div>
    </div>

    <div class="container">
      <div class="content-wrapper">
        <!-- Info Cards -->
        <div class="info-section">
          <div class="columns">
            <div class="column">
              <div class="card info-card">
                <div class="card-content">
                  <div class="media">
                    <div class="media-left">
                      <div class="icon-wrapper">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 10L12 12M12 12L10 14M12 12L10 10M12 12L14 14" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                          <path d="M4 16.2422C2.79401 15.435 2 14.0602 2 12.5C2 10.1564 3.79151 8.23129 6.07974 8.01937C6.54781 5.17213 9.02024 3 12 3C14.9798 3 17.4522 5.17213 17.9203 8.01937C20.2085 8.23129 22 10.1564 22 12.5C22 14.0602 21.206 15.435 20 16.2422" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                          <path d="M10 16H14" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                          <path d="M12 16V20" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                      </div>
                    </div>
                    <div class="media-content">
                      <h3>Create Content</h3>
                      <p>Make a post/reel showcasing your WitBlox project and mention "@WitBlox" in your caption</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="card info-card">
                <div class="card-content">
                  <div class="media">
                    <div class="media-left">
                      <div class="icon-wrapper">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 16V17M12 7V15M8 13V15M16 11V15M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                      </div>
                    </div>
                    <div class="media-content">
                      <h3>Earn Rewards</h3>
                      <p>Get 1 WitCoin for every 10 views and 5 WitCoins for every like</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Submit Button -->
        <div class="submit-section">
          <button class="button is-primary" @click="showSubmitModal = true">
            <span class="icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: middle;">
                <rect width="24" height="24" rx="6" fill="#fff" fill-opacity="0"/>
                <!-- Instagram Icon -->
                <path d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3 16V8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16Z" stroke="white" stroke-width="2"/>
                <path d="M16.5 7.5V7.501" stroke="white" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </span>
            <span>Submit Your Post/Reel</span>
          </button>
        </div>

        <!-- Submissions Section -->
        <div class="submissions-section">
          <h3>Your Submissions</h3>
          <div v-if="submissions.length === 0" class="empty-state">
            <img src="@/assets/img/instagram-empty.svg" alt="No submissions" /> <!-- Use Instagram specific empty state image -->
            <p>No posts submitted yet</p>
          </div>
          <div v-else class="video-grid">
            <div v-for="submission in submissions" :key="submission.id" class="shadcn-video-card" @click="openVideo(submission.url)" style="cursor: pointer;">
              <div class="shadcn-thumbnail-wrapper">
                <div class="shadcn-thumbnail" :style="{ backgroundImage: `url(${submission.thumbnail})` }">
                  <span class="shadcn-status-badge" :class="submission.status">{{ submission.status }}</span>
                  <button v-if="submission.status !== 'approved'" class="shadcn-delete-btn" @click="confirmDelete(submission.id)" title="Delete">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="5" y="6" width="14" height="14" rx="2" stroke="#ff0000" stroke-width="2"/>
                      <path d="M3 6h18" stroke="#ff0000" stroke-width="2" stroke-linecap="round"/>
                      <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke="#ff0000" stroke-width="2"/>
                      <path d="M10 11v4" stroke="#ff0000" stroke-width="2" stroke-linecap="round"/>
                      <path d="M14 11v4" stroke="#ff0000" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                  </button>
                </div>
              </div>
              <div class="shadcn-video-info">
                <div class="shadcn-stats-row">
                  <span class="shadcn-stat">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 12C1 12 5 5 12 5C19 5 23 12 23 12C23 12 19 19 12 19C5 19 1 12 1 12Z" stroke="#888" stroke-width="1.5" fill="none"/>
                      <circle cx="12" cy="12" r="3.5" stroke="#888" stroke-width="1.5" fill="none"/>
                    </svg>
                    {{ formatNumber(submission.views) }}
                  </span>
                  <span class="shadcn-stat">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 21C12 21 4 13.5 4 8.5C4 5.5 6.5 3 9.5 3C11.1 3 12 4.5 12 4.5C12 4.5 12.9 3 14.5 3C17.5 3 20 5.5 20 8.5C20 13.5 12 21 12 21Z" stroke="#888" stroke-width="1.5" fill="none"/>
                    </svg>
                    {{ formatNumber(submission.likes) }}
                  </span>
                  <span class="shadcn-stat coins-earned" v-if="submission.status === 'approved'">
                    <img src="@/assets/img/coin.svg" style="width: 13px; margin-right: 2px;" />
                    {{ formatNumber(submission.coinsEarned) }}
                  </span>
                </div>
                <div class="shadcn-date-row">
                  <span class="shadcn-date">{{ formatDate(submission.submittedAt) }}</span>
                </div>
                <div class="shadcn-sync-info">
                  <template v-if="submission.lastSynced === 0">
                    <span v-if="submission.status !== 'approved'">
                      Views and likes will update after approval. Once approved, stats will sync every 12 hours.
                    </span>
                    <span v-else>
                      Your post will be synced in the next 12 hours.
                    </span>
                  </template>
                  <template v-else-if="submission.status === 'approved'">
                    Stats update every 12 hours.
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Submit Modal -->
    <div v-if="showSubmitModal" class="shadcn-modal-outer">
      <div class="shadcn-modal-bg" @click="showSubmitModal = false"></div>
      <div class="shadcn-modal-card">
        <header class="shadcn-modal-card-head">
          <p class="shadcn-modal-card-title">Submit Post/Reel</p>
          <button class="shadcn-modal-close" aria-label="close" @click="showSubmitModal = false">&times;</button>
        </header>
        <section class="shadcn-modal-card-body">
          <div class="shadcn-field">
            <label class="shadcn-label">Instagram Post/Reel URL</label>
            <input
              class="shadcn-input"
              type="text"
              v-model="newSubmission.url"
              placeholder="https://www.instagram.com/p/..."
            />
          </div>
          <div class="shadcn-help-text">
            <p><strong>Note:</strong> Make sure to mention <span class="shadcn-highlight">@WitBlox</span> in your caption</p>
            <p>Rewards will be calculated after 30 days</p>
          </div>
        </section>
        <footer class="shadcn-modal-card-foot">
          <button
            class="shadcn-btn shadcn-btn-primary"
            :class="{'is-loading': isSubmitting}"
            @click="submitPost"
            :disabled="!isValidSubmission"
          >
            <span class="shadcn-btn-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="24" height="24" rx="6" fill="#fff" fill-opacity="0"/>
                <!-- Instagram Icon -->
                <path d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3 16V8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16Z" stroke="white" stroke-width="2"/>
                <path d="M16.5 7.5V7.501" stroke="white" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </span>
            <span>Submit</span>
          </button>
          <button class="shadcn-btn" @click="showSubmitModal = false">Cancel</button>
        </footer>
      </div>
    </div>
  </section>
</template>

<script>
import { db } from "@/main.js";
import { auth } from "@/main.js";
import { createWebengageEvent } from "../helper";
import placeholderImg from '@/assets/img/instagram-placeholder.svg';

export default {
  name: "instagram-star",
  data() {
    return {
      submissions: [],
      isSubmitting: false,
      showSubmitModal: false,
      newSubmission: {
        url: ""
      }
    };
  },
  computed: {
    isValidSubmission() {
      // Simple validation for Instagram URL
      return this.newSubmission.url &&
             this.newSubmission.url.includes('instagram.com');
    }
  },
  methods: {
    formatNumber(num) {
      if (num >= 1000000) {
        return (num / 1000000).toFixed(1) + 'M';
      } else if (num >= 1000) {
        return (num / 1000).toFixed(1) + 'K';
      }
      return num;
    },
    formatDate(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    },
    async submitPost() {
      if (!this.isValidSubmission) return;
      this.isSubmitting = true;
      try {
        const postId = this.getPostId(this.newSubmission.url);
        const submission = {
          url: this.newSubmission.url,
          userId: auth.currentUser.uid,
          status: 'pending',
          submittedAt: Date.now(),
          views: 0,
          likes: 0,
          coinsEarned: 0,
          lastSynced: 0,
          complete: false,
          claimed: false,
          postId: postId,
          thumbnail: '' // Always save a blank thumbnail field
        };
        await db.collection('insta-submissions').add(submission);
        createWebengageEvent({
          uid: auth.currentUser.uid,
          eventName: "Instagram Post Submitted",
          eventData: {
            url: submission.url
          }
        });
        this.newSubmission.url = "";
        this.showSubmitModal = false;
        this.loadSubmissions();
      } catch (error) {
        console.error('Error submitting post:', error);
      } finally {
        this.isSubmitting = false;
      }
    },
    async loadSubmissions() {
      const snapshot = await db.collection('insta-submissions')
        .where('userId', '==', auth.currentUser.uid)
        .orderBy('submittedAt', 'desc')
        .get();
      this.submissions = snapshot.docs.map(doc => {
        const data = doc.data();
        return {
          id: doc.id,
          ...data,
          thumbnail: data.thumbnail && data.thumbnail.trim() !== '' ? data.thumbnail : placeholderImg
        };
      });
    },
    getPostId(url) {
      const patterns = [
        /\/p\/([a-zA-Z0-9_-]+)/,
        /\/reel\/([a-zA-Z0-9_-]+)/
      ];
      for (const pattern of patterns) {
        const match = url.match(pattern);
        if (match && match[1]) return match[1];
      }
      return null;
    },
    async deleteSubmission(id) {
      try {
        await db.collection('insta-submissions').doc(id).delete();
        this.loadSubmissions();
      } catch (err) {
        alert('Failed to delete submission.');
      }
    },
    confirmDelete(id) {
      if (confirm('Are you sure you want to delete this submission?')) {
        this.deleteSubmission(id);
      }
    },
    openVideo(url) {
      if (url) window.open(url, '_blank');
    }
  },
  async mounted() {
    await this.loadSubmissions();
  }
};
</script>

<style scoped>
/* Use Instagram Gradient or primary color */
.instagram-star {
  min-height: 100vh;
  background-color: #fff;
  font-family: 'Poppins', sans-serif;
  padding-bottom: 100px;
}

.hero {
  /* Instagram Gradient */
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
  color: white;
  padding: 3rem 1.5rem;
  text-align: center;
}

.hero .title {
  font-family: 'Poppins', sans-serif;
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 2rem;
  letter-spacing: -0.5px;
  line-height: 1.2;
  color: white;
}

.hero .subtitle {
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
  opacity: 0.9;
  font-weight: 400;
  line-height: 1.4;
  color: white;
}

.content-wrapper {
  max-width: 1000px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
}

.info-section {
  margin: -3rem auto 2rem;
  position: relative;
  z-index: 1;
}

.info-card {
  height: 100%;
  border-radius: 8px;
  background: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.info-card .card-content {
  padding: 1.5rem;
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-left {
  margin-right: 1.5rem;
}

.icon-wrapper {
  width: 48px;
  height: 48px;
  background: #E1306C; /* Instagram Pink */
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}

.icon-wrapper:hover {
  transform: scale(1.05);
}

.icon-wrapper svg {
  width: 24px;
  height: 24px;
}

.media-content h3 {
  font-family: 'Poppins', sans-serif;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #363636;
}

.media-content p {
  font-family: 'Poppins', sans-serif;
  font-size: 0.9rem;
  color: #666;
  line-height: 1.5;
}

.submit-section {
  text-align: center;
  margin: 2rem 0;
}

.button.is-primary {
  background-color: #E1306C; /* Instagram Pink */
  border: none;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  padding: 0.75rem 1.5rem;
  height: auto;
  font-size: 0.9rem;
  color: white;
}

.button.is-primary:hover {
  background-color: #c13584; /* Darker Instagram Pink/Purple */
}

.submissions-section {
  margin-top: 2rem;
}

.submissions-section h3 {
  font-family: 'Poppins', sans-serif;
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: #363636;
  padding: 0;
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
  padding: 0.5rem;
}

/* shadcn/ui inspired video card */
.shadcn-video-card {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.07);
  margin-bottom: 1.5rem;
  padding: 0.7rem 0.7rem 1.1rem 0.7rem;
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  position: relative;
  transition: box-shadow 0.18s;
}

.shadcn-video-card:hover {
  box-shadow: 0 4px 24px rgba(0,0,0,0.13);
  background: #fafbfc;
}

.shadcn-thumbnail-wrapper {
  width: 100%;
  aspect-ratio: 16/9; /* Adjust if needed for IG square/portrait */
  position: relative;
  border-radius: 14px;
  overflow: hidden;
  background: #f3f3f3;
}

.shadcn-thumbnail {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  border-radius: 14px;
  position: relative;
  min-height: 120px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}

.shadcn-delete-btn {
  position: absolute;
  top: 12px;
  left: 12px;
  width: 36px;
  height: 36px;
  background: rgba(255,255,255,0.92);
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  box-shadow: 0 1px 4px rgba(0,0,0,0.07);
  transition: background 0.15s, box-shadow 0.15s;
}

.shadcn-delete-btn:hover {
  background: #ffeaea;
  box-shadow: 0 2px 8px rgba(255,0,0,0.08);
}

.shadcn-status-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 4px 16px;
  border-radius: 16px;
  color: #fff;
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  background: #888;
  z-index: 2;
  box-shadow: 0 1px 4px rgba(0,0,0,0.07);
}

.shadcn-status-badge.pending {
  background: #ffd700;
  color: #222;
}

.shadcn-status-badge.approved {
  background: #E1306C; /* Instagram Pink */
}

.shadcn-status-badge.rejected {
  background: #ff3860;
}

.shadcn-video-info {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  padding: 0 0.2rem;
}

.shadcn-stats-row {
  display: flex;
  align-items: center;
  gap: 1.2rem;
  margin-bottom: 0.2rem;
}

.shadcn-stat {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  color: #888;
  font-size: 0.93rem;
  font-weight: 500;
}

.coins-earned {
  color: #E1306C; /* Instagram Pink */
  font-weight: 600;
}

.shadcn-date-row {
  font-size: 0.85rem;
  color: #aaa;
  font-weight: 400;
}

.shadcn-date {
  font-size: 0.85rem;
  color: #aaa;
}

.shadcn-sync-info {
  font-size: 0.82rem;
  color: #888;
  margin-top: 0.2rem;
}

.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  color: #666;
  background: #f8f9fa;
  border-radius: 12px;
  margin: 0.5rem;
}

.empty-state img {
  width: 100px;
  margin-bottom: 1.5rem;
  opacity: 0.6;
}

.empty-state p {
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
  color: #555;
  font-weight: 400;
}

/* shadcn/ui inspired modal styles */
.shadcn-modal-bg {
  background: rgba(0,0,0,0.25);
}
.shadcn-modal-card {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
  max-width: 370px;
  margin: 0 auto;
  margin-top: 8vh;
  overflow: hidden;
  width: 95vw;
  display: flex;
  flex-direction: column;
  animation: fadeIn 0.2s;
}
.shadcn-modal-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.2rem 1.5rem 0.5rem 1.5rem;
  border-bottom: 1px solid #f3f3f3;
  background: #fff;
}
.shadcn-modal-card-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #222;
  margin: 0;
}
.shadcn-modal-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #888;
  cursor: pointer;
  line-height: 1;
  padding: 0 0.2rem;
  transition: color 0.15s;
}
.shadcn-modal-close:hover {
  color: #E1306C; /* Instagram Pink */
}
.shadcn-modal-card-body {
  padding: 1.5rem 1.5rem 0.5rem 1.5rem;
}
.shadcn-field {
  margin-bottom: 1.2rem;
}
.shadcn-label {
  display: block;
  font-size: 0.98rem;
  font-weight: 600;
  color: #222;
  margin-bottom: 0.5rem;
}
.shadcn-input {
  width: 100%;
  padding: 0.7rem 1rem;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  font-size: 1rem;
  background: #fafbfc;
  color: #222;
  outline: none;
  transition: border 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
}
.shadcn-input:focus {
  border: 1.5px solid #E1306C; /* Instagram Pink */
  box-shadow: 0 0 0 2px #e1306c33; /* Instagram Pink Glow */
}
.shadcn-help-text {
  font-size: 0.92rem;
  color: #666;
  margin-bottom: 0.5rem;
}
.shadcn-highlight {
  color: #E1306C; /* Instagram Pink */
  font-weight: 600;
}
.shadcn-modal-card-foot {
  display: flex;
  gap: 0.7rem;
  justify-content: flex-end;
  align-items: center;
  padding: 1.2rem 1.5rem 1.2rem 1.5rem;
  background: #fff;
  border-top: 1px solid #f3f3f3;
}
.shadcn-btn {
  border: none;
  border-radius: 8px;
  padding: 0.7rem 1.3rem;
  font-size: 1rem;
  font-weight: 600;
  background: #f3f3f3;
  color: #222;
  cursor: pointer;
  transition: background 0.18s, color 0.18s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.shadcn-btn-primary {
  background: #E1306C; /* Instagram Pink */
  color: #fff;
}
.shadcn-btn-primary:hover {
  background: #c13584; /* Darker Instagram Pink/Purple */
}
.shadcn-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.shadcn-btn-icon {
  display: flex;
  align-items: center;
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: none; }
}

@media screen and (max-width: 768px) {
  .hero .title {
    font-size: 1.75rem;
  }

  .content-wrapper {
    padding: 1rem;
  }

  .video-grid {
    grid-template-columns: 1fr;
  }

  .info-section {
    margin-top: -6rem;
  }
}

/* Update all text elements to use Poppins */
.button,
.input,
.label,
.help-text,
.help-text p,
.modal-card-title,
.hero .title,
.hero .subtitle,
.media-content h3,
.media-content p,
* {
  font-family: 'Poppins', sans-serif !important;
}

/* Modal outer wrapper for z-index stacking */
.shadcn-modal-outer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style> 